const str = {
  html: "html",
  css: "css",
  sass: "sass",
  tailwind: "tailwind",
  javascript: "javascript",
  typescript: "typescript",
  react: "react",
  redux: "redux",
  reanimated2: "reanimated2",
  react_navigation: "react-navigation",
  react_router: "react-router",
  react_testing_library: "react-testing-library",
  firebase: "firebase",
  git: "git",
};

export default str;
